import type { SectionConfig } from '../../config';
import { FieldsRenderer } from '../../fields-renderer';
import { SectionShell } from '../section-shell';

export type CoverageSectionProps = {
  config: SectionConfig;
};

// Structurally identical to `LeaseInformationSection` — kept separate so the
// four-section API in the engine stays explicit.
export function CoverageSection({ config }: CoverageSectionProps) {
  return (
    <SectionShell
      title={config.title}
      subtitle={config.subtitle}
      slots={config.slots}
      spacing={config.spacing}
    >
      <FieldsRenderer fields={config.fields} sectionKey="coverage" />
    </SectionShell>
  );
}
